
@if(isMobileView){
    <div
    class="absolute bottom-[85px] left-0 w-full rounded-t-lg bg-body-popup" [class.p-5]="show">
    
    <ul class="transition-500 m-0 flex flex-col gap-2.5 overflow-y-auto transition-[max-height]" [class]="show? 'max-h-[40svh]':'max-h-[0] '">
        @for (item of groups; track $index) {
        <li class="flex cursor-pointer justify-between p-2.5" [class.active]="item.group.GroupVersionsID == selectedGroup?.group?.GroupVersionsID"
            [class.!text-green-500]="item.checkedQuestions === item.questions.length" (click)="onGroupChanged(item)">
            <span>{{item.group.Name}}</span>
            <span>{{ item.checkedQuestions }}/{{ item.questions.length}}</span>
        </li>
        }
    </ul>
    </div>
}@else{
    <kendo-dropdownlist [textField]="'category.VersionsID'" [valueField]="'group.GroupVersionsID'" [data]="groups" [value]="selectedGroup"
    (valueChange)="onGroupChanged($event)">
    <ng-template kendoDropDownListValueTemplate let-dataItem>
        <span class="text-sm font-semibold text-default" [class.text-green-500]="dataItem.checkedQuestions === dataItem.questions.length">
            {{ dataItem.group.Name }} {{ dataItem.checkedQuestions }}/{{ dataItem.questions.length }}
        </span>
    </ng-template>
    <ng-template kendoDropDownListItemTemplate let-dataItem>
        <span class="text-sm font-semibold text-default" [class.text-green-500]="dataItem.checkedQuestions === dataItem.questions.length" >
            {{ dataItem.group.Name }} {{ dataItem.checkedQuestions }}/{{ dataItem.questions.length}}
        </span>
    </ng-template>
</kendo-dropdownlist>
}

  

 